import React from 'react';
import { DataTable } from '../../../../ui';
import type { IAdminDataTableProps, ITableRow } from '../interfaces';

/**
 * @deprecated Use common `DataTable` from `src/ui` directly.
 * Maintained as a compatibility adapter over `DataTable`.
 */
export const AdminDataTable = <T extends ITableRow>({
  columns,
  rows,
  isLoading,
  currentPage,
  totalPages,
  totalRecords,
  rowsPerPage,
  onPageChange,
  onRowClick,
  emptyTitle,
  emptySubtitle,
}: IAdminDataTableProps<T>) => {
  return (
    <DataTable<T>
      columns={columns}
      data={rows}
      isLoading={isLoading}
      currentPage={currentPage}
      totalPages={totalPages}
      totalRecords={totalRecords}
      rowsPerPage={rowsPerPage}
      onPageChange={onPageChange}
      onClickRow={onRowClick}
      emptyTitle={emptyTitle}
      emptySubtitle={emptySubtitle}
    />
  );
};
